import React from "react";
import { useAuth } from "@/context/AuthContext";

// Addendum 5 [ASUMSI]: an institution order without VAT — Owner only, with a
// reason (the server checks the role and that the customer is an institution).
export default function TanpaPpn({ value, onChange, testid = "tanpa-ppn" }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  return (
    <div>
      <label className="text-[13px] font-semibold text-slate-200">Tanpa PPN — alasan (Owner, opsional)</label>
      <input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Kosongkan bila instansi kena PPN"
        className="mt-1 w-full rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 focus:border-amber-500 focus:outline-none" />
    </div>
  );
}
